import React, { useState, useEffect } from 'react';
import './Admin.css';

const DuLieuCa = () => {
  const [shiftData, setShiftData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const fetchShiftData = async () => {
    setLoading(true);
    setError(null);
    try {
      // Xây dựng query string với các tham số filter
      const params = new URLSearchParams();
      if (fromDate) params.append('fromDate', fromDate);
      if (toDate) params.append('toDate', toDate);
      // Nếu có IDCH thì truyền thêm, ở đây giả sử không có filter IDCH ở UI, nếu cần thì bổ sung
      // params.append('idch', idch);

      const url = `https://doticom.vn:3000/api/sale-ket-ca?${params.toString()}`;
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Failed to fetch shift data');
      }
      const data = await response.json();

      // API đã trả về đúng dạng [{ Ngay, Ca: [...] }]
      setShiftData(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchShiftData();
  }, []);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('vi-VN', {
      style: 'currency',
      currency: 'VND'
    }).format(amount);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('vi-VN', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  // Không cần lọc lại theo ngày ở FE nữa, chỉ filter nếu cần theo IDCH ở FE
  const filteredData = shiftData;

  const calculateDayTotal = (shifts) => {
    if (!Array.isArray(shifts)) return 0;
    return shifts.reduce((total, shift) => total + shift.TienSauGiamGia, 0);
  };

  return (
    <div className="admin-main">
      <div className="admin-header">
        <div className="header-left">
          <h1>Dữ Liệu Ca Làm</h1>
          <p>Xem và quản lý thông tin các ca làm việc</p>
        </div>
      </div>

      <div className="content-section">
        <div className="card">
          <div className="card-header">
            <div className="section-header">
              <h2>Bộ Lọc</h2>
            </div>
            <div className="filters" style={{ display: 'flex', gap: '16px', alignItems: 'end' }}>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label htmlFor="fromDate">Từ ngày:</label>
                <input
                  type="date"
                  id="fromDate"
                  className="form-control"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label htmlFor="toDate">Đến ngày:</label>
                <input
                  type="date"
                  id="toDate"
                  className="form-control"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
              <button 
                className="btn btn-primary"
                onClick={fetchShiftData}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Đang tải...
                  </>
                ) : (
                  <>
                    <i className="fas fa-sync-alt me-2"></i>
                    Làm mới
                  </>
                )}
              </button>
            </div>
          </div>
        </div>

        {error && (
          <div className="card">
            <div className="card-body" style={{ textAlign: 'center', color: '#dc3545' }}>
              <i className="fas fa-exclamation-triangle" style={{ fontSize: '24px', marginBottom: '12px' }}></i>
              <p>Lỗi: {error}</p>
              <button className="btn btn-primary" onClick={fetchShiftData}>
                Thử lại
              </button>
            </div>
          </div>
        )}

        {loading && (
          <div className="card">
            <div className="card-body" style={{ textAlign: 'center', padding: '48px' }}>
              <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }}></div>
              <p style={{ marginTop: '16px', color: '#6c757d' }}>Đang tải dữ liệu...</p>
            </div>
          </div>
        )}

        {!loading && !error && filteredData.length === 0 && (
          <div className="card">
            <div className="card-body" style={{ textAlign: 'center', padding: '48px' }}>
              <i className="fas fa-inbox" style={{ fontSize: '48px', color: '#6c757d', marginBottom: '16px' }}></i>
              <h3 style={{ color: '#6c757d', marginBottom: '8px' }}>Không có dữ liệu</h3>
              <p style={{ color: '#6c757d' }}>Không tìm thấy dữ liệu ca làm trong khoảng thời gian đã chọn.</p>
            </div>
          </div>
        )}

        {!loading && !error && filteredData.map((dayData, dayIndex) => (
          <div key={dayIndex} className="card">
            <div className="card-header">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3 style={{ margin: 0, color: '#212529' }}>
                  <i className="fas fa-calendar-day me-2"></i>
                  {formatDate(dayData.Ngay)}
                </h3>
                <div className="stat-card" style={{ 
                  background: '#e3f2fd', 
                  padding: '8px 16px', 
                  borderRadius: '8px',
                  border: '1px solid #1976d2'
                }}>
                  <span style={{ fontSize: '14px', color: '#1976d2', fontWeight: '600' }}>
                    Tổng ngày: {formatCurrency(calculateDayTotal(dayData.Ca))}
                  </span>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Ca</th>
                      <th>Nhân viên</th>
                      <th>Thời gian kết ca</th>
                      <th>Tổng tiền</th>
                      <th>Giảm giá</th>
                      <th>Tiền sau giảm giá</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dayData.Ca.map((shift, shiftIndex) => (
                      <tr key={shiftIndex}>
                        <td>
                          <span className="badge bg-primary">
                            Ca {shift.CaID}
                          </span>
                        </td>
                        <td>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <i className="fas fa-user-circle" style={{ color: '#6c757d' }}></i>
                            <strong>{shift.TenNhanVien}</strong>
                          </div>
                        </td>
                        <td>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <i className="fas fa-clock" style={{ color: '#6c757d' }}></i>
                            {shift.ThoiGianKetCa}
                          </div>
                        </td>
                        <td>
                          <span style={{ fontWeight: '600', color: '#212529' }}>
                            {formatCurrency(shift.TongTien)}
                          </span>
                        </td>
                        <td>
                          <span style={{ 
                            color: shift.GiamGia > 0 ? '#dc3545' : '#6c757d',
                            fontWeight: shift.GiamGia > 0 ? '600' : '400'
                          }}>
                            {shift.GiamGia > 0 ? '-' : ''}{formatCurrency(shift.GiamGia)}
                          </span>
                        </td>
                        <td>
                          <span style={{ 
                            fontWeight: '700', 
                            color: '#28a745',
                            fontSize: '16px'
                          }}>
                            {formatCurrency(shift.TienSauGiamGia)}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ))}

        {!loading && !error && filteredData.length > 0 && (
          <div className="card">
            <div className="card-header">
              <h3 style={{ margin: 0, color: '#212529' }}>
                <i className="fas fa-chart-bar me-2"></i>
                Tổng kết
              </h3>
            </div>
            <div className="card-body">
              <div className="stats-grid">
                <div className="stat-card">
                  <div className="stat-header">
                    <div className="stat-icon">
                      <i className="fas fa-calendar-check"></i>
                    </div>
                  </div>
                  <div className="stat-content">
                    <div className="stat-value">{filteredData.length}</div>
                    <div className="stat-label">Số ngày</div>
                  </div>
                </div>
                <div className="stat-card">
                  <div className="stat-header">
                    <div className="stat-icon">
                      <i className="fas fa-business-time"></i>
                    </div>
                  </div>
                  <div className="stat-content">
                    <div className="stat-value">
                      {filteredData.reduce((total, day) => total + day.Ca.length, 0)}
                    </div>
                    <div className="stat-label">Tổng số ca</div>
                  </div>
                </div>
                <div className="stat-card">
                  <div className="stat-header">
                    <div className="stat-icon">
                      <i className="fas fa-money-bill-wave"></i>
                    </div>
                  </div>
                  <div className="stat-content">
                    <div className="stat-value" style={{ fontSize: '20px' }}>
                      {formatCurrency(
                        filteredData.reduce((total, day) => 
                          total + calculateDayTotal(day.Ca), 0
                        )
                      )}
                    </div>
                    <div className="stat-label">Tổng doanh thu</div>
                  </div>
                </div>
                <div className="stat-card">
                  <div className="stat-header">
                    <div className="stat-icon">
                      <i className="fas fa-percentage"></i>
                    </div>
                  </div>
                  <div className="stat-content">
                    <div className="stat-value" style={{ fontSize: '20px' }}>
                      {formatCurrency(
                        filteredData.reduce((total, day) => 
                          total + day.Ca.reduce((shiftTotal, shift) => 
                            shiftTotal + shift.GiamGia, 0
                          ), 0
                        )
                      )}
                    </div>
                    <div className="stat-label">Tổng giảm giá</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DuLieuCa;
